import * as Globals from "../../globals";
import {clearGroup, layoutCamera, render} from "../../sceneManager";
import {buildingGroup, clearStates, mousePosition, tmpGroup, toggleModeButtons} from "../../main";
import {findChildrenByName,sortPointsClockwise,sortObjClockwise} from "../../utils/threeUtils";
import {FlatRoof} from "./flatRoof";
import {disableLayer, enableLayerById, setObjectLayer} from "../../utils/layerUtils";
import {
    addDefaultCirclePointer,
    addNumberedDefaultCirclePointer,
    recolorPointer,
    repositionPointer
} from "../../utils/pointerUtils";
import {Vector3} from "three";
import {snapPointToGeometryBounds} from "../../utils/snappingUtils";
import {polygonNonSelfIntersecting} from "../../utils/geometryUtils";
import {createMeshFromPoints,pathPointsClockwise} from "../../utils/shapeUtils";
import {parseToFixedFloat} from "../../utils/utils";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";
import {generateMeasurements} from "../measurements/measurementGeneration";
import {RoofTypes} from "../../constants/roofConstants";
import {previewMaterial, previewNotAllowedMaterial} from "../../constants/materialConstants";
import {raehmMeshName, roofGroupName, supportBeamMeshName} from "../../constants/nameConstants";
import {showMessage} from "../../../ui/ui";
import {t} from "../../../i18n";
import { TransactionManager } from "../../TransactionManager";

let roofPoints = [];
let roofPointObjects = [];
let elements = [];
let roofSnapPointer = null;
let allRaehmMeshes = [];
let allSupportBeams = [];
let roofPreview = null;

//Dacherstellung
export function startManualRoofGeneration() {
    
    clearStates();
    Globals.setActiveMode(Globals.modes.roof);
    enableLayerById(layoutCamera, Globals.layers.raehm);
    roofSnapPointer = addDefaultCirclePointer(mousePosition);
    setObjectLayer(roofSnapPointer, Globals.layers.layoutViewOnly);
    allRaehmMeshes = findChildrenByName(buildingGroup, raehmMeshName, false, true);
    allSupportBeams = findChildrenByName(buildingGroup, supportBeamMeshName, false, true);
    document.querySelector('.manual-placement-instructions').style.display = 'block';
}

export function selectRoofPoints() {
    let loopClosed = false;
    let snappedObj = snapRoofPoint();
    let point = snappedObj.snapPoint;
    let element = snappedObj.snapObject;
    //Prüfen, ob eine geschlossene Shape erstellt wurde, sobald 3 Punkte geklickt wurden
    for (let i = 0; i < roofPoints.length; i++) {
        if (roofPoints[i].equals(point)) {;
            return;
        }
    }

    if (roofPoints.length && !onSameAxis(roofPoints[roofPoints.length-1], point)) {
        showMessage(t("roof_sibling_points"));
        return;
    }
    roofPoints.push(point);
    roofPointObjects.push(snappedObj.snapObject);

    // if (roofPoints.length > 3) {
    //     roofPoints = sortPointsClockwise(roofPoints);
    //     elements = sortObjClockwise(roofPoints, elements);
    //     roofPointObjects=[];
    //     elements.forEach((element, index) => {
    //         roofPointObjects.push(element.snapObject);
    //         addPointer(roofPoints[index], index);
    //     });
    // }
    loopClosed = roofPoints.length > 3 && roofPoints[0].equals(roofPoints[roofPoints.length-1]);

    //console.log({loopClosed:loopClosed, roofPoints:roofPoints, roofPointObjects:roofPointObjects, elements:elements});
    //addPointer(point, roofPoints.length);

    //Vorschau generieren so lange der loop noch nicht geschlossen wurde
    if (roofPoints.length > 2 && !loopClosed) {
        if (roofPreview !== null) {
            roofPreview.removeFromParent();
        }
        roofPreview = createMeshFromPoints(roofPoints);
        roofPreview.position.y = point.y + 0.1;
        roofPreview.name = "roofPreviewShape";
        setObjectLayer(roofPreview, Globals.layers.layoutViewOnly);
        buildingGroup.addWithUuid(roofPreview);
    }

    if (loopClosed) {
        createRoof(true);
    }

    render();

    return loopClosed;
}

function onSameAxis(p1, p2, delta=0.05) {
    let deltaX = Number(Math.abs(p1.x - p2.x).toFixed(3));
    let deltaZ = Number(Math.abs(p1.z - p2.z).toFixed(3));

    return deltaX <= delta || deltaZ <= delta;
}

function addPointer(point, number)
{
    let pointerPosition = new Vector3(point.x, point.y + 0.2, point.z);
    let pointer = addNumberedDefaultCirclePointer(pointerPosition, number);
    setObjectLayer(pointer, Globals.layers.layoutViewOnly, true);
}

export function snapRoofPoint() {
    //Snappen der Mausposition an die Eckpunkte des Rähm der Wandelemente & Unterzügen
    let snappingObject = snapPointToGeometryBounds([...allRaehmMeshes].concat(allSupportBeams));
    let snapPoint = snappingObject.snapPoint;

    if (snapPoint !== null) {
        //Gefundenen Snappunkt markieren
        let pointerPosition = new Vector3().copy(snapPoint);
        pointerPosition.y = 4;
        repositionPointer(roofSnapPointer, pointerPosition);
        recolorPointer(roofSnapPointer, previewMaterial);
        return snappingObject;
    } else {
        //Wenn nicht an Geometrie gesnappt werden konnte wird die originale Mausposition genutzt und optisch als ungültige Position markiert
        let pointerPosition = new Vector3().copy(mousePosition);
        pointerPosition.y = 4;
        repositionPointer(roofSnapPointer, pointerPosition);
        recolorPointer(roofSnapPointer, previewNotAllowedMaterial);
        return {snapPoint: mousePosition, snapObject: null};
    }
}

export function finishRoofPointSelection() {
    if (roofPoints.length > 3) {
        roofPoints.push(new Vector3().copy(roofPoints[0]));
        roofPointObjects.push(roofPointObjects[0]);
        createRoof(true);
    } else {
        console.error("Dach konnte nicht erstellt werden. Bitte wähle mindestens 4 Dachpunkte aus.");
        showMessage(t("roof_min_points"));
    }
}

export function createRoof(manualMode = false) {
    toggleModeButtons();
    let roof = findChildrenByName(buildingGroup, roofGroupName);
    if (roof.length > 0) {
        console.error("Dach existiert bereits. Erstellung mehrerer Dächer ist nicht möglich.");
        showMessage(t("roof_exists"));
        return;
    }

    if (manualMode && !polygonNonSelfIntersecting(roofPoints)) {
        console.error("Dachpunkte ergeben keine gültige Form");
        showMessage(t("roof_invalid_shape"));
        return;
    }

    let roofType = 1;//parseInt(document.querySelector('input[name="roof-type-input"]:checked').value);
    let roofOverhang = parseToFixedFloat($('#roof-overhang-input').val());
    let roofOrientation = parseToFixedFloat($('#roof-orientation-select').val());
    let addAttika = $('#roof-add-attika-input').prop('checked');
    let attikaHeight = parseToFixedFloat($('#roof-add-attika-height-input').val());

    try {
        if (roofType === RoofTypes.FlatRoof) {
            TransactionManager.startTransaction();
            let flatRoof = new FlatRoof(roofOverhang, roofOrientation, addAttika, attikaHeight, roofPoints, roofPointObjects);
            if (flatRoof !== undefined) {
                if (flatRoof.create() !== undefined) {
                    showMessage(t("roof_thickness", {thickness: flatRoof.thickness * 1000}), "Hinweis");
                }
                $('#outerWallBtn').trigger('wallCreated', ['roofPlacement']);
            }
            
        }
    } catch (e) {
        //console.log("error on creating roof");
        //console.error(e.message);
        console.log(e);
        showMessage(e.message);
    } finally {
        recalculateBuildingParameters().then();
        generateMeasurements().then();

        //Clear State
        clearRoofState();
        Globals.setActiveMode(Globals.modes.view);
        clearGroup(tmpGroup);
        render();
        TransactionManager.stopTransaction();
    }
}

export function getRoof()
{
    let roof = findChildrenByName(buildingGroup, roofGroupName);
    if (roof.length <= 0) {
        return null;
    }

    return roof[0];
}

export async function regenerateRoof(overwriteValues = null) {
    let roof = getRoof();
    if (!roof) {
        return;
    }
    clearStates();

    //Get roof values
    let roofType, orientation, overhang, addAttika, attikaHeight;
    if (overwriteValues === null) {
        roofType = roof.userData.roof.type;
        orientation = roof.userData.roof.orientation;
        overhang = roof.userData.roof.overhang;
        addAttika = roof.userData.roof.addAttika;
        attikaHeight = roof.userData.roof.attikaHeight;
    } else {
        roofType = overwriteValues.roofType;
        orientation = overwriteValues.orientation;
        overhang = overwriteValues.overhang;
        addAttika = overwriteValues.addAttika;
        attikaHeight = overwriteValues.attikaHeight;
    }

    if (!roof.userData.roof.automatic) {
        roofPoints = roof.userData.roof.points;
    }

    let existingThickness = roof.userData.roof.thickness;
    clearGroup(roof);
    roof.removeFromParent();

    //TODO Für weitere Dachtypen erweitern
    if (roofType === RoofTypes.FlatRoof) {
        try {
            let flatRoof = new FlatRoof(overhang, orientation, addAttika, attikaHeight, roofPoints, roofPointObjects);
            if (flatRoof !== undefined) {
                if (flatRoof.create(true) !== undefined) {
                    if (flatRoof.thickness === existingThickness) {
                        // showToast("Deckenstärke des erstellten Dachs beträgt: " + (this.thickness * 1000) + "mm")
                    } else {
                        showMessage(t("roof_thickness_new", {thickness: flatRoof.thickness * 1000}), "Hinweis");
                    }
                }
            }
        } catch (e) {
            console.error(e.message);
            showMessage(e.message);
        } finally {
            recalculateBuildingParameters().then();
            generateMeasurements().then();
        }
    }
}

export function clearRoofState() {
    document.querySelector('.manual-placement-instructions').style.display = 'none';
    roofPoints = [];
    roofPointObjects = [];
    elements = [];
    if (roofPreview !== null) {
        clearGroup(roofPreview);
        roofPreview.removeFromParent();
    }
    if (roofSnapPointer !== null) {
        clearGroup(roofSnapPointer);
        roofSnapPointer.removeFromParent();
        roofSnapPointer = null;
    }
    disableLayer(layoutCamera, Globals.layers.raehm);
}
